document.addEventListener('DOMContentLoaded', function() {
  const accountLoginUrl = document.querySelector('.account_login_url');
  const myAccountDropdown = document.querySelector('.myaccount_dropdown_menu');
  let timeout;
  function showDropdown() {
    myAccountDropdown.classList.add('myaccount_dropdown_menu_open');
  }
  function hideDropdown() {
    myAccountDropdown.classList.remove('myaccount_dropdown_menu_open');
  }
  accountLoginUrl.addEventListener('mouseover', showDropdown);
  accountLoginUrl.addEventListener('click', function(event) {
    event.preventDefault(); // Empêche le lien de s'ouvrir dans une nouvelle fenêtre
    showDropdown();
  });
  // Gérer la fermeture du menu
  function closeDropdown() {
    timeout = setTimeout(hideDropdown, 200); // Délai avant de fermer le menu
  }
  function cancelCloseDropdown() {
    clearTimeout(timeout);
  }
  myAccountDropdown.addEventListener('mouseenter', cancelCloseDropdown);
  myAccountDropdown.addEventListener('mouseleave', closeDropdown);

  accountLoginUrl.addEventListener('mouseleave', closeDropdown);
});